import React from "react";
import { Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import config from "appconfig";
import { useAxios } from "components";
import "./footer.scss";

type LastUpdateResponse = {
  lastUpdatedUtc: string | null;
};

const Footer = () => {
  const location = useLocation();
  const path = location.pathname;
  const hideFooter = path.includes("/map") || path.startsWith("/analytics");
  const { fetch } = useAxios<LastUpdateResponse>();
  const [lastUpdatedUtc, setLastUpdatedUtc] = React.useState<string | null>(
    null
  );

  React.useEffect(() => {
    if (hideFooter) return;

    (async () => {
      try {
        const res = await fetch({
          url: `${config.apiBaseUrl}/version/last-data-update`,
          method: "GET",
        });
        setLastUpdatedUtc(res.data.lastUpdatedUtc);
      } catch (e) {
        console.warn("last-data-update error", e);
      }
    })();
  }, [hideFooter, fetch]);

  const lastUpdateText = React.useMemo(() => {
    if (!lastUpdatedUtc) return null;
    const dt = new Date(lastUpdatedUtc);
    if (Number.isNaN(dt.getTime())) return null;
    return dt.toLocaleString();
  }, [lastUpdatedUtc]);

  if (hideFooter) return null;

  return (
    <footer className="px-2 py-4">
      <Container fluid>
        <Row>
          <small>
            &copy;{new Date().getFullYear()} - City of Columbus
            {lastUpdateText ? `, Last Data Update: ${lastUpdateText}` : ""}
          </small>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
